export const mListHelper = {
  mListEditStatus: ["New", "Planned"],
  mItemEditForm: (d) => mListHelper.mListEditStatus.includes(d.status),
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceList/mListHelper.js